import { useCallback } from 'react'

import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { unproxify } from '@/utils'
import { deleteRoadSegments } from '@/features/domain/roadSegment'

import { useController } from './useController'

export function useDeleteRoadSegment() {
  const {
    data: { roadSegmentIds },
    close,
  } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()

  const isUnmounted = useIsUnmounted()

  return useCallback(async () => {
    try {
      const segmentIds = unproxify(roadSegmentIds)
      const result = await dispatch(deleteRoadSegments(segmentIds))

      if (!deleteRoadSegments.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }
    } catch (e) {
      toast.error(e.message)
    } finally {
      close?.()
    }
  }, [dispatch, toast, roadSegmentIds, close, isUnmounted])
}
